import TextVisualizer from "../../../components/widgets/TextVisualizer";
import { useSelector } from "react-redux";
import { useGlobalContext } from "../../../context";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import { formatDate } from "../../../utils/FormatDates";
import {
  CommentSection,
  CommentStats,
  Orden,
  OrdenInfo,
  PersonInfo,
  PersonInfoSub,
} from "./WorkOrderElements";
import UserImage from "../../svg/UserImage";

import { request } from "../../../store/modules/RequestStore";
import { useState } from "react";
import TabFiles from "../../../pages/Request/TabFiles";
import { useTranslation } from "react-i18next";
import TranslatableText from "../../Multilanguage/TranslatableText";

export const Card = ({ workOrder }) => {
  const requestState = useSelector(request);
  const [showFiles, setShowFiles] = useState(false);
  const [modalRemoveFile, setModalRemoveFile] = useState(false);
  const [filesToRemoveList, setfilesToRemoveList] = useState([]);
  const { secundaryColor, color7 } = useGlobalContext();

  const { t } = useTranslation();

  const handleShowFiles = () => {
    setShowFiles(!showFiles);
  };
  return (
    <Orden
      bg={secundaryColor}
      className={`flex flex-col rounded-md p-2 sm:p-8 w-full my-4 mt-4`}
    >
      <TextVisualizer className="font-semibold ml-2 break-words" value="400">
        {requestState.active.Subject}
      </TextVisualizer>
      <OrdenInfo>
        <PersonInfo className="justify-center">
          <UserImage note={workOrder} />
          <div>
            <div className="w-2/3 text-md">
              <p className={`font-title text-${color7}`}>{t("workOrders.responsible")}:</p>
              <p className={`md:text-md text-gray-700 font-semibold mb-2`}>
                {workOrder.TechnicianName}
              </p>
              <div className="grid-rows">
                <PersonInfoSub>
                  <p className={`font-title text-${color7}`}>{t("workOrders.code")} </p>
                  <p>-</p>
                  <span className="md:font-body text-gray-700">
                    {workOrder.ID}
                  </span>
                </PersonInfoSub>
                <PersonInfoSub>
                  <p className={`font-title text-${color7}`}>
                    {t("workOrders.statusDesc")}{" "}
                  </p>
                  <p>-</p>
                  <span className={`md:font-body text-gray-700`}>
                    <TranslatableText text={workOrder.StatusDescription} />
                  </span>
                </PersonInfoSub>
              </div>
            </div>
          </div>
        </PersonInfo>
        <div className="flex flex-col items-center gap-4">
          <p className={`font-title text-${color7}`}>
            {t("workOrders.progress")}:
          </p>
          <CircularProgressbar
            className="w-24 h-24"
            value={workOrder.Percentage ? parseInt(workOrder.Percentage) : 0}
            text={`${workOrder.Percentage}%`}
            styles={buildStyles({
              // Rotation of path and trail, in number of turns (0-1)
              rotation: 0,

              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
              strokeLinecap: "round",

              // Text size
              textSize: "16px",

              // How long animation takes to go from one percentage to another, in seconds
              pathTransitionDuration: 0.5,

              // Can specify path transition in more detail, or remove it entirely
              // pathTransition: 'none',

              // Colors
              pathColor: "#3DEA83",
              textColor: "#000032",
              trailColor: "#3948FF",
              backgroundColor: "#3DEA83",
            })}
          />
        </div>
      </OrdenInfo>
      {workOrder.filesWorkOrder.length > 0 && (
        <>
          <span
            onClick={handleShowFiles}
            className={`cursor-pointer mt-3 flex font-title underline items-center gap-2 mb-4 text-${color7}`}
          >
            {showFiles ? t("workOrders.hideFiles") : t("workOrders.showFiles")}
            {showFiles ? (
              <span>
                <svg
                  width="19"
                  height="10"
                  viewBox="0 0 19 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 9L9.5 1L18 9"
                    stroke="#645ABE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            ) : (
              <span>
                <svg
                  width="19"
                  height="10"
                  viewBox="0 0 19 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L9.5 9L18 1"
                    stroke="#645ABE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </span>
          {showFiles && (
            <TabFiles
              ID={workOrder.ID}
              modalRemoveFile={modalRemoveFile}
              requestState={requestState}
              setModalRemoveFile={setModalRemoveFile}
              filesToRemoveList={filesToRemoveList}
              setfilesToRemoveList={setfilesToRemoveList}
              uploadedFiles={workOrder.filesWorkOrder}
              folder={"3"}
              canUpload={false}
            />
          )}
        </>
      )}

      <div className="mt-4 ">
        <div className="my-2 w-full">
          <p className="font-semibold mb-2 ">{t("workOrders.advance")}</p>
          <div className="flex flex-col gap-2">
            {workOrder.Advances.map((advance, index) => {
              return (
                <CommentSection
                  key={index}
                  className={`bg-white border border-gris rounded-lg p-7 flex flex-col md:justify-between gap-72`}
                >
                  <div className="break-words w-full">
                    <div className="md:advance-description">
                      <TextVisualizer value="200">
                        {advance.Description}
                      </TextVisualizer>
                    </div>
                  </div>
                  <div className="grid text-md gap-1 self-center">
                    <CommentStats>
                      <p className={`font-title text-${color7}`}>
                        {t("workOrders.code")}{" "}
                      </p>
                      <p>-</p>
                      <span className="font-body">{advance.AdvancementID}</span>
                    </CommentStats>
                    <CommentStats>
                      <p className={`font-title text-${color7}`}>
                        {t("workOrders.measnAttention")}
                      </p>
                      <p>-</p>
                      <span className="font-body">
                        <TranslatableText text={advance.Via} />
                      </span>
                    </CommentStats>
                    <CommentStats>
                      <p className={`font-title text-${color7}`}>
                        {t("workOrders.progress")}{" "}
                      </p>
                      <p>-</p>
                      <span className="font-body">{advance.Progress}%</span>
                    </CommentStats>
                    <CommentStats>
                      <p>{formatDate(advance.StartDate)}</p>
                      <p>-</p>
                      <p>{formatDate(advance.EndDate)}</p>
                    </CommentStats>
                  </div>
                </CommentSection>
              );
            })}
          </div>
        </div>
      </div>
    </Orden>
  );
};
